import React, { memo, useMemo } from 'react';
import { formatCurrency } from '../../utilities/general-utils';

/**
 * Memoized component for displaying account summary information
 * Only re-renders when account data actually changes
 */
const AccountSummary = memo(({ account }) => {
    const summaryData = useMemo(() => {
        if (!account.paymentSchedule || account.paymentSchedule.length === 0) {
            return {
                totalPayments: 0,
                totalInterest: 0,
                monthsToPayoff: 0,
                finalPaymentDate: null
            };
        }

        const totalPayments = account.paymentSchedule.reduce((sum, payment) => sum + payment.totalPayment, 0);
        const totalInterest = account.paymentSchedule.reduce((sum, payment) => sum + payment.interestPaid, 0);
        const monthsToPayoff = account.paymentSchedule.length;
        const finalPaymentDate = account.paymentSchedule[account.paymentSchedule.length - 1]?.date;

        return {
            totalPayments,
            totalInterest,
            monthsToPayoff,
            finalPaymentDate
        };
    }, [account.paymentSchedule]);

    return (
        <div className="account-summary" style={{ 
            padding: '1rem', 
            backgroundColor: '#f8f9fa', 
            borderRadius: '4px',
            marginBottom: '1rem'
        }}>
            <h4 style={{ margin: '0 0 0.5rem 0' }}>
                {account.name} - {formatCurrency(account.balance)}
            </h4>
            
            {summaryData.monthsToPayoff > 0 ? (
                <div style={{ fontSize: '0.9rem', color: '#666' }}>
                    <div>Payoff Time: {summaryData.monthsToPayoff} months ({(summaryData.monthsToPayoff / 12).toFixed(1)} years)</div>
                    <div>Total Payments: {formatCurrency(summaryData.totalPayments)}</div>
                    <div>Total Interest: {formatCurrency(summaryData.totalInterest)}</div>
                    {summaryData.finalPaymentDate && (
                        <div>Final Payment: {new Date(summaryData.finalPaymentDate).toLocaleDateString()}</div>
                    )}
                </div>
            ) : (
                <div style={{ fontSize: '0.9rem', color: '#999' }}>
                    Payment schedule not calculated
                </div>
            )}
        </div>
    );
});

AccountSummary.displayName = 'AccountSummary';

export default AccountSummary;